export default {"src":"/_next/static/media/search-icon-bold.693b10ca.svg","height":20,"width":20};